import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class MessageService {

	private message = new Subject<any>();
	constructor() { }

	/**
	 * Handle send message functionality
	 * @param message : object having message data
	 */
	sendMessage(message: object) {
		this.message.next(message);
	}

	/**
	 * Handle get message functionality
	 */
	getMessage(): Observable<any> {
		return this.message.asObservable();
	}
}
